import { useState, useEffect, KeyboardEventHandler } from 'react'
import { useLocation } from 'react-router';
import CreatableSelect from 'react-select/creatable'

const MajorKeyword = ({ keywordSelect, setKeywordSelect }) => {

  const location = useLocation()

  const [selectInput, setSelectInput] = useState('')

  const createOption = (label: string) => ({
    label: label,
    value: label,
  });

  const handleKeyDown: KeyboardEventHandler = (event) => {
    if (!selectInput) return;
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        setKeywordSelect((prev) => [...prev, createOption(selectInput)]);
        setSelectInput('');
        event.preventDefault();
    }
  };

  useEffect(() => {

    let params = new URLSearchParams(location.search);
    let keywordParam = params.get('keyword');

    if (keywordParam) {
      let keywords = keywordParam.split(',').map(res => ({ label: res, value: res }));
      setKeywordSelect(keywords)
    }

  }, [location.search]);

  return (
    <div className='mt-4 d-flex flex-column'>
      <div className='dca-aside-header'>KEYWORDS</div>
      <CreatableSelect
        components={{
          DropdownIndicator: null
        }}
        inputValue={selectInput}
        isClearable
        isMulti
        noOptionsMessage={() => "Start typing..."}
        onChange={(newValue) => setKeywordSelect(newValue || [])}
        onInputChange={(newValue) => setSelectInput(newValue)}
        onKeyDown={handleKeyDown}
        placeholder="Enter keyword(s)..."
        value={keywordSelect}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            border: 'transparent',
            backgroundColor: '#F9F9F9'
          })
        }}
      />
    </div>
  )
}

export { MajorKeyword }